import { useEffect } from "react";
import { useLinkToRoot } from "@circle-react/hooks/useLinkToRoot";
import { useLiveStreamsFeatureFlags } from "@circle-react/hooks/useLiveStreamsFeatureFlags";

export const useNotSupportedRedirect = () => {
  const { goToCommunityRootPath } = useLinkToRoot();
  const { isPublicLiveStreamsEnabled, isLoading } =
    useLiveStreamsFeatureFlags();

  useEffect(() => {
    if (!isLoading && !isPublicLiveStreamsEnabled && goToCommunityRootPath) {
      goToCommunityRootPath();
    }
  }, [goToCommunityRootPath, isLoading, isPublicLiveStreamsEnabled]);
};
